export const getTimeString36 = () => new Date().getTime().toString(36)
